<template>
  <div class="tags-box">
    <el-dialog
      :title="'图集详情'"
      :visible.sync="dialogVisible"
      width="680px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="picturePopup">
        <el-upload
          ref="upload"
          :action="action"
          multiple
          list-type="picture-card"
          name="upload[]"
          :on-success="successCallback"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :headers="header"
          :file-list="fileList"
          accept="image/jpeg, image/png, image/jpg, image/gif"
          :limit="150"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="handleClose()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";

export default {
  data() {
    return {
      id: "",
      flag: false,
      dialogVisible: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      imgUrl: baseConfig.imgUrl,
      pics: undefined,
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      header: {
        Authorization: local.get("userInfo").token,
      },
      fileList: [], // 用于编辑图片回显
    };
  },
  methods: {
    // 封面图上传成功回调
    successCallback(res) {
      if (!this.pics) {
        this.pics = [];
      }
      this.pics = this.pics.concat(res.data.filePath);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    handleRemove(file) {
      this.pics = this.pics.filter((item) => {
        if (file.response) {
          if (item != file.response.data.coverImg) {
            return item;
          }
        } else {
          if (item != file.name) {
            return item;
          }
        }
      });
    },
    // 打开弹窗并初始化tags数据
    open(pictureArr) {
      this.pics = pictureArr;
      this.fileList = pictureArr.map((item) => {
        return {
          name: item,
          url: this.imgUrl + item,
        };
      });
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.pics = undefined;
    },
  },
};
</script>
<style scoped lang="scss">
.tags-box {
  .el-dialog {
    padding: 0 !important;
    margin: 0 !important;
  }
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
  .picturePopup {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: 580px;
    .pictureInside {
      margin: 5px;
      position: relative;
      .deleteButton {
        position: absolute;
        opacity: 0.5;
        top: 0;
        right: 0;
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 150px;
    height: 150px;
    .el-upload-list__item-delete {
      display: none;
    }
  }
  /deep/ .el-upload--picture-card {
    width: 150px;
    height: 150px;
    line-height: 170px;
    display: none;
  }
}
</style>
